"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _core = require("core.ui-module_site-components");
var _ApplicationContext = require("../api/ApplicationContext");
var _SecurityContextHolder = require("../api/SecurityContextHolder");
var _MenuHistoryHolder = require("../api/MenuHistoryHolder");
var _PageSecurity = require("../api/authz/PageSecurity");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class SecureComponent extends _react.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "goBack", () => {
      const {
        history
      } = this.props;
      history.goBack();
    });
    this.state = {
      user: undefined,
      isLoading: true,
      isAllowed: false
    };
  }
  componentDidMount() {
    const {
      match,
      history,
      menuItem
    } = this.props;
    const {
      location
    } = history;
    const {
      path
    } = match;
    _SecurityContextHolder.SecurityContextHolder.generateRouteUUID();

    // Check if context states user is authenticated
    if (!_SecurityContextHolder.SecurityContextHolder.isAuthenticated()) {
      this.setState({
        user: null,
        isLoading: false
      });
      return;
    }
    const user = _SecurityContextHolder.SecurityContextHolder.getCurrentContext();
    if (user == null) {
      history.push(_ApplicationContext.ApplicationContext.getLoginPath());
    }
    const routePath = path === '/' ? '/home.html' : path;
    let referrerPathname = '/';
    const menuHistory = _MenuHistoryHolder.MenuHistoryHolder.getHistory();
    if (menuHistory && menuHistory.length > 1) {
      referrerPathname = menuHistory[menuHistory.length - 1].pathname;
    }

    /**
     * The following code will check the Security Manager to determine if the page is allowed.
     * It is important to note that this content might not be reached as there will not be a
     * REACT component defined for the particular URL being requested (these would have
     * typically resulted in the 403 response below).
     *
     */
    // Check that the page is allowed.
    (0, _PageSecurity.isAllowed)(routePath, referrerPathname).then(() => {
      this.setState({
        user,
        isLoading: false,
        isAllowed: true
      });
      _MenuHistoryHolder.MenuHistoryHolder.addHistory(location, menuItem);
    }).catch(error => {
      if (!error.response || error.response.status === 403) {
        this.setState({
          user,
          isLoading: false,
          isAllowed: false
        });
      } else if (error.response.status === 401) {
        window.location.href = _ApplicationContext.ApplicationContext.getLogoutPath();
      } else {
        history.push(referrerPathname);
      }
    });
  }
  render() {
    const {
      isLoading,
      isAllowed,
      errorMessage
    } = this.state;
    if (isLoading) {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "lds-spinner-overlay"
      }, /*#__PURE__*/_react.default.createElement(_core.Spinner, null));
    }
    if (isAllowed) {
      return this.props.children;
    }
    if (_ApplicationContext.ApplicationContext.getDefaultLoginMethod() === 'token' && _ApplicationContext.ApplicationContext.getOverrideDefaultPath()) {
      return /*#__PURE__*/_react.default.createElement(_core.WarningNotification, {
        status: "Unable to Process Request",
        footer: /*#__PURE__*/_react.default.createElement(_core.Button, {
          className: "button is-primary",
          handleClick: this.goBack
        }, "OK")
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "columns is-centered mb-2"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "column is-half-desktop"
      }, "The requested URL is not valid.  Please click 'Ok' to return")));
    }
    return /*#__PURE__*/_react.default.createElement(_core.OkModal, {
      header: "Unable to Process Request",
      message: "The requested URL is not valid.  Please click 'Ok'' to return",
      display: true,
      closeModalCallback: this.goBack,
      key: errorMessage
    });
  }
}
exports.default = SecureComponent;
SecureComponent.propTypes = {
  menuItem: _propTypes.default.shape({
    theme: _propTypes.default.string
  }),
  history: _propTypes.default.shape({
    push: _propTypes.default.func.isRequired,
    goBack: _propTypes.default.func.isRequired,
    listen: _propTypes.default.func.isRequired,
    location: _propTypes.default.shape({
      pathname: _propTypes.default.string.isRequired
    })
  }),
  match: _propTypes.default.shape({
    path: _propTypes.default.string
  }),
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.string])
};

// TimeoutModal.defaultProps = {
//   logoutPath: '/logout.html',
//   timeout: ApplicationContext.getSiteInactiveTimeout(),
// };
//# sourceMappingURL=SecureComponent.js.map